export const FIREBASE_API_KEY = process.env.FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = process.env.FIREBASE_AUTH_DOMAIN;
export const FIREBASE_URL = process.env.FIREBASE_URL;
export const FIREBASE_STORAGE_BUCKET = process.env.FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID = process.env.FIREBASE_MESSAGING_SENDER_ID;
export const APP_NAME = 'webchat';
export const LOGIN_PATH = '/login';
export const DEFAULT_POST_LOGIN_PATH = '/channels/general';
export const POST_LOGOUT_PATH = LOGIN_PATH;



// WEBPACK FOOTER //
// ./src/config.js